<template>
  <div>
    <v-container fluid class="pa-0">
      <!-- <material-card icon="mdi-clipboard-text" inline title="View Vehicle Details"> -->
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="ml-2">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                  Logs For Student - Route Mapping - Vehicle Mapping
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <div style="padding:20px"></div>
          <div class="mb-3">Student List for {{journeyTypeName}} Journey</div>
            <template>
              <div class="flext-container">
                <div class="grid-table tableheaderbg">
                  <div class="table-column"> </div>
                  <div class="table-column"></div>

                  <div v-for="(stop,index) in visibleVehicles" :key="stop.id" class="table-column">
                    <div class="arrow-row">
                      <div class="arrow left-arrow" v-if="index===0"
                        :class="{ disabled: currentFirstColumn === 0 }"
                        @click="slideLeft"
                      >
                        &#x276E;
                      </div>

                      <div class="arrow right-arrow" v-if="index===visibleColumns-1"
                          :class="{ disabled: currentFirstColumn + visibleColumns >= tableHeaders.length }"
                          @click="slideRight"
                        >
                          &#x276F;
                        </div>
                    </div>
                  </div>

                  <div class="table-column extra-column" v-if="glimpseVehicle.length">
                  </div>

                </div>
              </div>
            </template>

            <!-- <div>Student List for {{journeyType}} Journey</div> -->

            <template>
                <div class="flext-container">

                  <div class="grid-table">

                    <!-- Sr. No. Column -->
                    <div class="table-column">
                      <h3 class="header">Sr. No.</h3>
                      <div
                        v-for="(element, index) in Array.from({ length: maxCapacity }, (_, i) => i+1)"
                        :key="element"
                        class="table-cell"
                      >
                        {{ index + 1 }}
                      </div>
                    </div>

                    <!-- Student List Column -->
                    <div class="table-column">
                      <h3 class="header">Student List</h3>
                      <div
                        v-for="(element) in studentList"
                        :key="element.name"
                        class="vuedraggable--dragging table-cell"
                        :style="{
                            color: element.action === 'remove' ? 'red' :
                                   element.action === 'add' ? 'green' : 'inherit'
                        }"
                      >
                        {{ element.name }} - {{element.destinationName}}
                      </div>
                      <div v-for="i in (maxCapacity - studentList.length)" :key="i" class="table-cell"></div>
                    </div>

                    <!-- Dynamic Stop Columns -->

                    <div v-for="stop in visibleVehicles" :key="stop.id" class="table-column">
                      <h3 class="header">{{ stop.text }}</h3>
                        <div
                          v-for="(element, index) in stop.studentList"
                          :key="element.name"
                          class="vuedraggable--dragging table-cell"
                          :style="{
                            color: element.action === 'remove' ? 'red' :
                                   element.action === 'add' ? 'green' : 'inherit'
                          }"
                        >
                          <span class="seat-label">S{{ index + 1 }}</span> {{ element.name }}
                        </div>
                    <div v-for="element in Array.from({ length: stop.seatingCapacity - stop.studentList.length }, (_, i) => stop.studentList.length + i + 1)"
                        :key="`emtpy-seat-${element}`"
                        class="table-cell"
                      >
                        <span class="seat-label">S{{ element }}</span>
                      </div>

                      <div
                        v-for="element in Array.from({ length: maxCapacity - stop.seatingCapacity }, (_, i) => stop.studentList.length + i + 1)"
                        :key="`no-seat-element-${element}`"
                        class="table-cell empty-cell"
                      >
                        <span class="seat-label"></span>
                      </div>
                    </div>

                    <div class="table-column extra-column" v-if="glimpseVehicle.length">
                      <h3 class="header">{{glimpseVehicle[0].text.slice(0, 6) + "..."}}</h3>
                      <div v-for="n in maxCapacity" :key="`extra-${n}`" class="table-cell"></div>
                    </div>

                  </div>
                </div>

              </template>

      </v-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>

<script>
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'

export default {
  name: 'StudentDestinationLogDetails',
  components: {
    // MaterialCard
    //  VCardComponent
    // draggable
  },
  data () {
    return {
      props: ['logID', 'dataID', 'logType'],
      franchiseeID: null,
      isLoading: false,
      inProgress: false,
      journeyType: null,
      journeyTypeName: null,
      destinations: [],
      maxSeatingCapacity: 0,
      vehicleAssigneToCount: 0,
      routeAssignedStudentCount: 0,
      tableHeaders: [],
      studentList: [],
      studentDestinationLogList: [],
      orignalDataCopy: null,
      studentLogsDetails: [],
      LogData: [],
      startIndex: 0, // The index of the first visible column
      columnsToShow: this.tableHeaders && this.tableHeaders.length < 4 ? this.tableHeaders.length : 3,
      visibleColumns: 4,
      currentFirstColumn: 0
    }
  },
  mounted () {},
  async created () {
    this.item = this.$route.params.item
    this.dataID = this.$route.query.dataID
    this.logType = this.$route.query.logType

    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
    await this.getVendorLogsDetails()
  },
  watch: {
    franchisee: async function () {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee'
    }),
    visibleHeaders () {
      return this.tableHeaders.slice(this.startIndex, this.startIndex + this.columnsToShow)
    },
    isAtStart () {
      return this.startIndex === 0
    },
    isAtEnd () {
      return this.startIndex + this.columnsToShow >= this.tableHeaders.length
    },
    maxCapacity () {
      return Math.max(this.studentList.length, ...this.tableHeaders.map(v => v.seatingCapacity))
    },
    visibleVehicles () {
      return this.tableHeaders.slice(this.currentFirstColumn, this.currentFirstColumn + this.visibleColumns)
    },
    glimpseVehicle () {
      return this.tableHeaders.slice(this.currentFirstColumn + this.visibleColumns, this.currentFirstColumn + this.visibleColumns + 1)
    }
  },
  methods: {
    slideLeft () {
      if (this.currentFirstColumn > 0) {
        this.currentFirstColumn -= 1
      }
    },
    slideRight () {
      if (this.currentFirstColumn + this.visibleColumns < this.tableHeaders.length) {
        this.currentFirstColumn += 1
      }
    },
    checkMove (evt) {
      console.log(evt, 'move')
    },
    handleDrop (evt, stop) {
      console.log(stop.studentList.length, stop.seatingCapacity, evt)
      if (stop.studentList.length > stop.seatingCapacity) {
        // const oldIndex = evt.oldIndex
        // const newIndex = evt.newIndex
        let replacedSeat = stop.studentList.pop()
        this.studentList.push(replacedSeat)
      }
    },
    nextColumns () {
      if (this.startIndex + this.columnsToShow < this.tableHeaders.length) {
        this.startIndex++
      }
    },
    prevColumns () {
      if (this.startIndex > 0) {
        this.startIndex--
      }
    },
    getVendorLogsDetails: async function () {
      try {
        if (this.franchiseeID && this.dataID && this.logType) {
          const response = await http.get(`${constants.API_URL}/api/transport/vendors/${this.franchiseeID}/logs?dataID=${this.dataID}`)
          let keyName
          if (this.logType === 'old') {
            keyName = 'oldData'
          }
          if (this.logType === 'new') {
            keyName = 'newData'
          }
          if (!response.data.logs[0][keyName]) {
            this.$router.push({ name: 'StudentDestinationMap' })
            return
          }
          let data = response.data.logs[0][keyName]
          console.log(data, '===--data')
          this.journeyType = response.data.logs[0] ? response.data.logs[0].dataSecondaryID : null
          if (this.journeyType === 'Only Pickup') {
            this.journeyTypeName = 'PickUp'
          }
          if (this.journeyType === 'Only Drop') {
            this.journeyTypeName = 'Drop'
          }
          this.studentList = data.parkedStudentList
          this.tableHeaders = data.rows
          this.vehicleAssigneToCount = data.vehicleAssigneToCount
          this.routeAssignedStudentCount = data.routeAssignedStudentCount
          this.maxSeatingCapacity = Math.max(data.maxSeatingCapacity, this.studentList.length)
        } else {
          // this.$router.push({ name: 'StudentDestinationMap' })
          return
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.snackbar.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 5000,
          position: 'is-bottom-right',
          actionText: 'Close'
        })
        // this.$router.push({ name: 'VendorViewOnly' })
      }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
          if (this.franchiseeID) {
            this.getVendorLogsDetails()
          }
        } else {
          this.franchiseeID = ''
        }
        this.inProgress = false
      }
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },

    formatDate (createdDate) {
      const date = new Date(createdDate)
      return date.toLocaleDateString()
    },
    formatTime (createdTime) {
      const time = new Date(createdTime)
      return time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })
    }

  }
}
</script>
<style scoped>
.alloctionstopdrag {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

}
.alloctionstopdrag .col-2.border2{
  padding: 0px;
}
.alloctionstopdragrow{
    display: flex;
    overflow-x: hidden;
    flex-wrap: initial;
    padding: 15px 0px;
}
.alloctionstopdragview .list-group .list-group-item, .alloctionstopdragview .list-group-item{
    font-size: 13px;
    color: #424242;
    letter-spacing: 0.3px;
    text-transform: capitalize;

}
.alloctionstopdragrow .alloctionstopdragview:first-child{
  background: #E3F2FD;
}
.alloctionstopdragrow .alloctionstopdragview:last-child{
  background: #E3F2FD;
  border-right: 1px solid #e0e0e0!important;
}
.alloctionstopdragview h3{
  text-align: center;
  margin: 0;
  padding: 10px;
  background-color: #f4f4f4;
  border-bottom: 1px solid #000; /* Separate the header from the content */
}
.alloctionstopdragview .list-group .list-group-item:hover{
  color: black;
    font-weight: 400;
}

.stopallocationviewcolor .v-btn__content{
  color: #fff;
}

.border2 {
  border: 0.5px solid #000; /* Add border around each cell */
}

.list-group {
  padding: 0;
  list-style-type: none;
  margin: 0;
}

.list-group-item {
  padding: 10px;
  border: 0.5px solid #000; /* Add border between items */
}

.new-row {
  height:50px;
  display: flex;
  overflow-x: hidden;
  width: 100%;
  flex-wrap: nowrap;

}

.disabled-button .icon {
  color: lightgrey;
}

.active-button .icon {
  color: black; /* or any color you prefer */
}

.flext-container {
  display: flex;
  flex-direction: column
}

.arrow-row {
  display: flex;
}

.arrow {
  text-align: center;
  font-size: 1.5rem;
  cursor: pointer;
  user-select: none;
  transition: transform 0.3s;
}

.arrow.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.arrow:hover:not(.disabled) {
  transform: scale(1.2);
}

.slide-enter-active, .slide-leave-active {
  transition: all 0.5s ease;
}

.slide-enter, .slide-leave-to {
  transform: translateX(100%);
}

.arrow:hover {
  transform: scale(1.2);
}

.left-arrow {
  grid-column: 3 / 4;
}

.right-arrow {
  grid-column: span 1;
}

.grid-table {
  display: grid;
  grid-template-columns: 80px repeat(5, 1fr) 100px; /* Dynamic columns */
  gap: 0; /* Ensure no gaps between columns */
  width: 100%;
  border-collapse: collapse; /* Collapse all borders */
}

.table-column {
  display: flex;
  flex-direction: column;
  border: 0.3px solid #0000005e; /* Full column border */
  transition: transform 0.3s ease;
}

.extra-column {
  border: none;
  color: black;
  opacity: 0.4;
  border: 0.3px solid #0000005e;

}

.table-cell, .header {
  padding: 10px;
  text-align: center;
  border: 0.3px solid #0000005e; /* Individual cell border */
  background-color: white;
  position: relative; /* Enable absolute positioning for seat-label */
    transition: background-color 0.3s, transform 0.3s ease; /* Smooth transition when item moves */

}

.table-cell.empty-cell {
  background-color: #f0f0f0; /* Grey background for empty cells */
    transition: background-color 0.3s;

}

h3.header {
  text-align: center;
  border-bottom: 0.3px solid #0000005e;
  margin: 0;
}

.seat-label {
  position: absolute;
  top: 5px;
  right: 5px;
  font-weight: 400;
  font-size: 14px
}

.table-cell {
  height: 70px; /* Ensures consistent row height */
}

.vuedraggable--dragging .table-cell {
  opacity: 0.8; /* Make it visually distinct when dragging */
  transform: scale(1.05); /* Slightly enlarge while dragging */
  transition: transform 0.2s ease-in-out, opacity 0.2s; /* Animation for dragging */

}

/* Animation for moving items */
.move {
  transition: transform 0.5s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
.tableheaderbg .table-column {
    background: #5d58ef;
    border: 1px solid #ccc;
    border-bottom: none !important;
}

</style>
